// src/lib/ukLocale.js
import { uk } from 'date-fns/locale';

export const ukWithLocalize = {
  ...uk,
  localize: {
    ...uk.localize,
    day: (n) => ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'][n],
    month: (n) => [
      'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень',
      'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'
    ][n],
    ordinalNumber: (n) => `${n}-й`
  },
  formatLong: {
    date: () => 'dd MMMM yyyy',
    time: () => 'HH:mm',
    dateTime: () => 'dd MMMM yyyy HH:mm'
  }
};
